<script setup>
import { defineProps, watch, defineEmits } from 'vue'
import useDetail from './hooks/useComponent'
const emit = defineEmits(['update:visible'])
const props = defineProps({
  // 那种类型的详情
  recordType: { type: String, default: 'prescriptionOnline', required: true },
  width: { type: String, default: '80%' },
  // 是否可见
  visible: {
    type: Boolean,
    default: false,
    required: true
  },
  // 随访通过 id
  // 量表的id
  id: {
    type: [String, Number],
    default: ''
  },
  // 处方通过编号
  // 量表的发送id
  serialNumber: {
    type: String,
    default: ''
  },
  mode: {
    // 模式，默认为空，read模式下所有操作按钮都不能进行
    type: String,
    default: ''
  },
  recordIsPre: {
    type: String,
    default: ''
  },
  planType: {
    type: Number,
    default: 0
  },
  // 判断用药计划还是随访
  visitPageType: {
    type: Number,
    default: null
  },
  // 操作类型
  operateType: {
    type: Number,
    default: null
  },
  // 患者PID
  pid: {
    type: String,
    default: ''
  },
  // 医院ID
  hospitalId: {
    type: Number,
    default: null
  },
  // uc患者ID
  ucPatientId: {
    type: Number,
    default: null
  }
})
const { component, activeKey, jumpTo, details, resetActive, removeOneDetail } = useDetail(props)
function noDetail(id, serialNumber) {
  removeOneDetail(id, serialNumber)
}
function onCancel() {
  resetActive()
  emit('update:visible', false)
}
watch(
  () => props.visible,
  visible => {
    if (!visible) return
    const id = props.id
    const is = props.recordType
    const serialNumber = props.serialNumber
    jumpTo(is, id, serialNumber)
  }
)
const bodyStyle = {
  maxHeight: '80vh',
  overflowY: 'scroll'
}
</script>
<template>
  <a-modal
    :footer="null"
    :width="width"
    :visible="visible"
    @cancel="onCancel"
    :bodyStyle="bodyStyle"
  >
    <a-tabs class="tabs" type="card" v-model:activeKey="activeKey">
      <a-tab-pane v-for="detail in details" :key="detail.key" :tab="detail.name">
        <component
          class="modalBody"
          :is="component[detail.is].is"
          :id="detail.id || props.id"
          :mode="mode"
          :checklistId="detail.id + ''"
          :serialNumber="detail.serialNumber"
          :visible="props.visible"
          :planType="planType"
          :visitPageType="visitPageType"
          v-on="{
            jumpTo,
            noDetail
          }"
          :recordIsPre="props.recordIsPre"
          :MRecordType="props.recordType"
          :MRecordId="props.id"
          :MOperateType="props.operateType"
          :MPid="props.pid"
          :MHospitalId="props.hospitalId"
          :MUcPatientId="props.ucPatientId"
          :params="{
            surveyId: detail.id,
            surveySendId: detail.serialNumber
          }"
        />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<style lang="scss" scoped>
.title {
  display: flex;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
